export default __webpack_public_path__ + "static/media/BOD Special Meeting 22 January 2021.7381e56a.pdf";